import React from 'react';
import styles from './SignupSuccessPanel.module.css'; 
import { InnocodeButton } from '@intsoft/innocode-core';

function SignupSuccessPanel({ onSkip, onEasyLogin }) {
  return (
    <>
      <div className={styles.signup_section}>
        <div className={styles.success_content}>
          <div className={styles.success_icon_box}>
            <img
              src="https://storage.innocode.co/api/v1/storage/files/content/329a688e-45ef-442a-a90f-af8f7e40dcb1"
              alt="success-icon"
              className={styles.success_icon}
            />
          </div>
          <div className={`innocode-typography--title-lg innocode-typography--bold ${styles.title_text}`}>
            환영합니다!
            <br />
            회원가입이 완료되었어요 :)
          </div>
          <div className={`innocode-typography--body-sm-reading innocode-typography--regular ${styles.description_text}`}>
            저희 서비스에 오신 걸 환영해요!
            <br />
            만드신 계정의 이메일 아이디로 간편 로그인이 가능하도록
            <br />
            설정을 도와드릴까요?
          </div>
        </div>
      </div>
      <div className={styles.submit_btn_container}>
        <InnocodeButton size="lg" onClick={onSkip} designType={'assistive'} theme={'line'} className={styles.submit_btn}>
          건너뛰기
        </InnocodeButton>
        <InnocodeButton size="lg" onClick={onEasyLogin} className={styles.submit_btn}>
          간편로그인 연동
        </InnocodeButton> 
      </div>
    </>
  );
}

export default SignupSuccessPanel;
